// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  const response = await request<{code: number, message: string, data: any}>('/api/currentUser', {
    method: 'GET',
    headers: {
      // 从 localStorage 获取 token 并添加到请求头
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
  
  // 后端返回的是 model.UserInfo，需要转换为前端期望的格式
  if (response.data) {
    const userInfo = response.data;
    const currentUser: API.CurrentUser = {
      name: userInfo.email, // 使用邮箱作为显示名称
      username: userInfo.username,
      avatar: userInfo.avatar,
      userid: userInfo.userid?.toString(),
      email: userInfo.email,
      access: userInfo.role,
    };
    return { data: currentUser };
  }
  
  // 如果后端返回 null，则返回 null
  return { data: null };
}

/** 获取完整的用户信息（包含UV和到期时间） GET /api/currentUser */
export async function getUserInfo(options?: { [key: string]: any }) {
  const response = await request<{code: number, message: string, data: any}>('/api/currentUser', {
    method: 'GET',
    headers: {
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
  
  // 返回完整的用户信息
  if (response.data) {
    return { data: response.data };
  }
  
  return { data: null };
}

/** 退出登录接口 POST /api/v1/auth/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/v1/auth/logout', {
    method: 'POST',
    headers: {
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
}

/** 获取验证码接口 GET /api/v1/auth/captcha */
export async function getCaptcha(options?: { [key: string]: any }) {
  return request<{code: number, message: string, data: { captchaId: string; captchaImage: string }}>('/api/v1/auth/captcha', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/v1/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const response = await request<{code: number, message: string, data: any}>('/api/v1/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
  
  // 响应异常不能当作密码错误，也不能覆盖现有登录凭证。
  if (response?.code !== 200 || typeof response.data?.token !== 'string' || !response.data.token.trim()) {
    throw new Error(response?.message && response.code !== 200 ? response.message : '登录响应异常，请稍后重试或联系管理员');
  }
  localStorage.setItem('token', response.data.token);
  
  // 返回data部分，让前端代码正常工作
  return response.data;
}

/** 修改密码接口 POST /api/v1/auth/change-password */
export async function changePassword(body: { oldPassword: string; newPassword: string }, options?: { [key: string]: any }) {
  return request<{code: number, message: string}>('/api/v1/auth/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
}

/** 发送验证码接口 POST /api/v1/auth/send-verification-code */
export async function sendVerificationCode(body: { email: string }, options?: { [key: string]: any }) {
  return request<{code: number, message: string}>('/api/v1/auth/send-verification-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true, // 跳过全局错误处理器，让业务代码自己处理错误
    ...(options || {}),
  });
}

/** 带验证码的注册接口 POST /api/v1/auth/register-with-code */
export async function registerWithCode(body: { username: string; password: string; email: string; verificationCode: string }, options?: { [key: string]: any }) {
  return request<{code: number, message: string, data?: any}>('/api/v1/auth/register-with-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 图形验证码注册接口 POST /api/v1/auth/register */
export async function register(body: { username: string; password: string; email: string; captchaId: string; captchaCode: string; invite_code?: string }, options?: { [key: string]: any }) {
  return request<{code: number, message: string, data?: any}>('/api/v1/auth/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

// 邮箱配置相关API
export async function getEmailConfigs(options?: { [key: string]: any }) {
  return request<{code: number, message: string, data: any[]}>('/api/v1/email-configs', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
}

export async function createEmailConfig(body: any, options?: { [key: string]: any }) {
  return request<{code: number, message: string, data: any}>('/api/v1/email-configs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateEmailConfig(id: number, body: any, options?: { [key: string]: any }) {
  return request<{code: number, message: string, data: any}>(`/api/v1/email-configs/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteEmailConfig(id: number, options?: { [key: string]: any }) {
  return request<{code: number, message: string}>(`/api/v1/email-configs/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
}

export async function activateEmailConfig(id: number, options?: { [key: string]: any }) {
  return request<{code: number, message: string}>(`/api/v1/email-configs/${id}/activate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    ...(options || {}),
  });
}

export async function testEmailConfig(id: number, body: { toEmail: string; subject?: string; content?: string }, options?: { [key: string]: any }) {
  return request<{code: number, message: string}>(`/api/v1/email-configs/${id}/test`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
